import React from 'react';

export default function ShippingPolicyPage() {
  return (
    <main data-testid="shipping-page" className="pt-20 min-h-screen">
      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#C6A978] mb-6">Policies</p>
          <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tighter text-[#1E1C1A] mb-12">
            Shipping Policy
          </h1>

          <div className="space-y-10 text-base font-light leading-relaxed tracking-wide text-[#7A7369]">
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">Processing Time</h2>
              <p>All orders are processed within 2-3 business days. Ready-to-ship pieces are dispatched within 24 hours. Custom and bespoke orders require 4-6 weeks for completion.</p>
            </div>

            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">Domestic Shipping</h2>
              <p>We offer complimentary shipping within India via premium insured courier. Standard delivery takes 3-5 business days. Express delivery (1-2 business days) is available at an additional charge.</p>
            </div>

            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">International Shipping</h2>
              <p>International orders are shipped via DHL Express or FedEx with full insurance and tracking. Delivery typically takes 5-10 business days depending on the destination. Import duties and taxes are the responsibility of the recipient.</p>
            </div>

            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">Packaging</h2>
              <p>Every piece is carefully packaged in our signature KIRAQ box — handcrafted, satin-lined, and tied with our signature ribbon. All packaging is made from sustainably sourced materials.</p>
            </div>

            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">Insurance</h2>
              <p>All shipments are fully insured against loss, theft, and damage during transit. In the unlikely event of an issue, please contact us immediately for a resolution.</p>
            </div>

            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">Tracking</h2>
              <p>You will receive a tracking number via WhatsApp and email once your order has been dispatched. You can track your package at any time through the courier's website.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
